module.exports = __webpack_public_path__ + "img/topic3-r.57a525d0.jpg";